import { render, staticRenderFns } from "./SalespersonDetails.vue?vue&type=template&id=2dd655a6"
import script from "./SalespersonDetails.vue?vue&type=script&lang=js"
export * from "./SalespersonDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports